// SESSION STORAGE
// Add to Session Storage
export const getSessionStorage = (key) => sessionStorage.getItem(key);
// Add JSON to Session Storage 
export const getSessionStorageJSON = (key) => JSON.parse(getSessionStorage(key));
// Get from Session Storage
export const setSessionStorage = (key, value) => sessionStorage.setItem(key, value);
// Get JSON from Session Storage 
export const setSessionStorageJSON = (key, value) => setSessionStorage(key, JSON.stringify(value));
// Delete from Session Storage
export const removeSessionStorage = (key) => sessionStorage.removeItem(key);

// LOCAL STORAGE
// Add to Local Storage
export const getLocalStorage = (key) => localStorage.getItem(key);
// Add JSON to Local Storage 
export const getLocalStorageJSON = (key) => JSON.parse(getLocalStorage(key));
// Get from Local Storage
export const setLocalStorage = (key, value) => localStorage.setItem(key, value);
// Get JSON from Local Storage 
export const setLocalStorageJSON = (key, value) => setLocalStorage(key, JSON.stringify(value));
// Delete from Local Storage
export const removeLocalStorage = (key) => localStorage.removeItem(key);